import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./Config/Config";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';
import App from './App';
import { registerMsalInstance } from './Services/authToken';

const msalInstance = new PublicClientApplication(msalConfig);

// Toute requête axios portant un Bearer repart désormais avec un token frais (cf. authToken.js).
// Enregistré AVANT le premier rendu : aucune requête ne part sans que l'intercepteur soit armé.
registerMsalInstance(msalInstance);

// Ignore ResizeObserver errors (non-critical)
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _ = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce(callback, 20);
    super(callback);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
// Ensure MSAL is initialized before rendering the app
msalInstance.initialize().then(() => {
  root.render(
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
          </PersistGate>
        </Provider>
      </MsalProvider>
  );
});


